import React from 'react';
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { setAuthLoaded, setFullscreenLogMessage, setMediaBrowser } from '../../redux/actions';
import { lzGetAssetUrl } from '../../services/LzUtils';
import PublicLayout from "./public";
import ImgLogo from '../../assets/images/logo.png';
import ImgLzLogo from '../../assets/images/lz-logo.png';
import LzDimmer from '../commons/dimmer';
import { lzCallApi } from '../../services/LzApiService';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import PrivateLayoutMainBar from './partials/private-main-bar';
import { getNavItems } from './partials/nav-items';
import { lzGetFormattedDate } from '../../services/LzMoment';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { lzKebabToWordCase } from '../../services/LzStrings';
import CloseIcon from '@material-ui/icons/Close';
import MediaBrowserComponent from '../screens/private/system/media/browser';
import { lzGetFromLocalStorage, lzSaveToLocalStorage } from '../../services/LzLocalStorage';

class PrivateLayout extends React.Component {

  constructor(props) {
    super(props);

    // Parse the url to get breadcrumbs
    this.paths = window.location.hash.split('/').filter(x => x).slice(1);
    this.route = '/' + this.paths.join('/');

    // Initialize state
    this.state = {
      drawerOpen: lzGetFromLocalStorage('layoutDrawerOpen', true),
      sideNavItems: getNavItems(props.authDealer, this.paths),
    };
  }

  componentDidMount() {
    this.checkLogin();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { authToken, authDealer } = this.props;

    // Check login if auth token has changed
    if (prevProps.authToken !== authToken) {
      this.checkLogin();
    }

    // If auth user has changed then re-build side-nav
    if (prevProps.authDealer !== authDealer) {
      // Re-build side-nav
      this.setState({ sideNavItems: getNavItems(authDealer, this.paths) });
    }
  }

  checkLogin() {
    const { authToken, authLoaded, setAuthLoaded, history } = this.props;

    // console.log('CHECKING LOGIN', authToken, authLoaded);

    // Check for logged in user
    if (!authToken || '' === authToken) {
      // TODO: Save current screen location to be redirected to after login/register
      setAuthLoaded(false);
      history.push('/user/login');
    }

    // Check if logged in but fresh data not loaded for this window
    if (!authLoaded) {
      // Call the load api and set loaded to true.
      lzCallApi('load-auth-data');
      setAuthLoaded(true);
    }
  }

  sideNavItemRootClick(dex) {
    const { sideNavItems } = this.state;
    sideNavItems[dex].open = !sideNavItems[dex].open;
    this.setState({ sideNavItems: sideNavItems });
  }

  mediaBrowserFail(msg) {
    const { mediaBrowserData, setMediaBrowser } = this.props;
    if (mediaBrowserData) {
      mediaBrowserData.failureCallback(msg);
      setMediaBrowser(null);
    }
  }

  toggleDrawer() {
    const { drawerOpen } = this.state;
    const updated = !drawerOpen;
    this.setState({ drawerOpen: updated }, () => lzSaveToLocalStorage('layoutDrawerOpen', updated));
  }

  render() {
    const { drawerOpen, sideNavItems } = this.state;
    const { screenTitle, breadcrumbPaths, children, showLoading, authDealer, fullscreenLogMessage, setFullscreenLogMessage, mediaBrowserData } = this.props;

    // console.log('authDealer', authDealer);
    // console.log('NAVITEMS', sideNavItems);

    let pathTrack = '/';

    return (
      <PublicLayout>

        {fullscreenLogMessage !== '' &&
          <div className="lz-fullscreen-log">
            <CloseIcon onClick={() => setFullscreenLogMessage('')} />
            <div dangerouslySetInnerHTML={{ __html: fullscreenLogMessage }} className="lz-log-content"></div>
          </div>
        }

        {(authDealer && !showLoading) ?
          <div className="lz-private-wrapper">

            <PrivateLayoutMainBar
              drawerOpen={drawerOpen}
              onDrawerToggle={() => this.toggleDrawer()}
            />

            <div className="lz-private-drawer-wrapper">

              <Drawer
                variant="persistent"
                anchor="left"
                open={drawerOpen}
              >
                <img src={lzGetAssetUrl(ImgLogo)} alt='Logo' />
                <Divider />
                <div className="lz-drawer-nav">
                  <List>
                    {sideNavItems.map((obj, dex) =>
                      <React.Fragment key={'drawer-nav-' + dex}>
                        {obj.items ?
                          <React.Fragment>
                            <ListItem button onClick={() => this.sideNavItemRootClick(dex)}>
                              <ListItemIcon>{obj.icon}</ListItemIcon>
                              <ListItemText>{obj.title}</ListItemText>
                              {obj.open ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={obj.open} timeout="auto" unmountOnExit>
                              <List component="div" disablePadding>
                                {obj.items.map((obj2, dex2) =>
                                  <ListItem
                                    selected={this.route === obj2.route}
                                    key={'drawer-nav2-' + dex2}
                                    component={Link}
                                    to={obj2.route}
                                  >
                                    <ListItemIcon>{obj2.icon}</ListItemIcon>
                                    <ListItemText>{obj2.title}</ListItemText>
                                  </ListItem>
                                )}
                              </List>
                            </Collapse>
                          </React.Fragment>
                          :
                          <ListItem component={Link} to={obj.route}>
                            <ListItemIcon>{obj.icon}</ListItemIcon>
                            <ListItemText>{obj.title}</ListItemText>
                          </ListItem>
                        }
                      </React.Fragment>
                    )}
                  </List>
                </div>
              </Drawer>

              <main className={'lz-screen-main' + (drawerOpen ? ' drawer-open' : '')}>
                <div className='main-header'>
                  <h1>{screenTitle || ''}</h1>
                  <Breadcrumbs aria-label="breadcrumb">
                    <Link to="/">Home</Link>
                    {this.paths.map((path, dex) => {
                      pathTrack += path + '/';
                      if (breadcrumbPaths && breadcrumbPaths[dex] && breadcrumbPaths[dex].title) {
                        return <Link to={breadcrumbPaths[dex].route} key={'path-' + dex}>{breadcrumbPaths[dex].title}</Link>;
                      }
                      return <Link to={pathTrack} key={'path-' + dex}>{'records' === path ? 'Activites' : lzKebabToWordCase(path)}</Link>;
                    })}
                  </Breadcrumbs>
                </div>
                <div className='main-content'>

                  {children}

                </div>
                <div className='main-footer'>
                  <div>Copyright &copy; {lzGetFormattedDate('', 'Y')} - All Rights Reserved.</div>
                  <a className='powered-by' href="https://logic-zone.net/?ref=services.2adata" target="_blank" rel="noreferrer">Powered by <img src={lzGetAssetUrl(ImgLzLogo)} alt="Logic Zone" /></a>
                </div>
              </main>

            </div>

          </div>
          :
          <LzDimmer active />
        }

        {mediaBrowserData &&
          <Dialog fullScreen open onClose={() => this.mediaBrowserFail('Cancelled by user!')}
            PaperProps={{
              style: {
                width: '90vw',
                height: '90vh',
                padding: 9,
                paddingBottom: 0,
                borderRadius: 3,
              }
            }}>
            <MediaBrowserComponent
              forSelection
              params={mediaBrowserData.params}
              onSelect={(media) => mediaBrowserData.successCallback(media)}
              onCancel={(msg) => mediaBrowserData.failureCallback(msg)}
            />
          </Dialog>
        }

      </PublicLayout>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    authDealer: state.auth.dealer,
    authToken: state.auth.token,
    authLoaded: state.auth.loaded,
    fullscreenLogMessage: state.commons.fullscreenLogMessage,
    mediaBrowserData: state.commons.mediaBrowserData,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    setAuthLoaded: (value) => dispatch(setAuthLoaded(value)),
    setFullscreenLogMessage: (value) => dispatch(setFullscreenLogMessage(value)),
    setMediaBrowser: (data) => dispatch(setMediaBrowser(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PrivateLayout));
